<script>
  import Card from '/Atoms/Card'

  export let artwork

  console.log(artwork)

</script>

<Card 
    flow 
    link={{slug: artwork.slug, section:"artwork"}}
    paddingStyle="article"  
  >
  <div class="card">
    <span class="title">
      { artwork.title }
      {#if true}
        {#if artwork.artworkYear }
          <span class="year">
            { artwork.artworkYear }
          </span>
        {/if}
      {/if}
    </span>
    <span class="name">
      { artwork?.relatedPeople?.[0]?.members?.map( member => member.title).join(", ") || "" }
    </span>
  </div>
</Card>

<style lang="scss">

  .card {
    @include typo-serif-text-28;

    a {
      display: block;
    }
    .title {
      display: block;
      font-style: italic;
      display: inline-flex;
      .year {
        font-style: normal;
        &:before {
          content: ", "
        }
      }
    }
    .name {
      display: block;
    }
  }


</style>